<template >
  <div class="justify-content-between align-items-center content-sidebar px-1 py-1">
    <hr>
        <b-form>
            <b-row>
                <b-col
                    cols="12"
                    class="mb-2"
                >
                    <h5 class="mb-0">
                        CRIAR NOVO CENTRO DE TRABALHO
                    </h5>
                </b-col>

                <b-col md="12">
                    <b-form-group
                    label="Nome"
                    label-for="name"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                    <b-form-input
                    id="name"
                    v-model="name"
                    placeholder="Welders"
                    :state="nomeState"
                    />
                    </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Centro de Custo"
                    label-for="costCenter"
                    :class="stateErrorCentroCusto && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="costCenter"
                        :options="contextoList.cost_centers.map((item) => {return {label: item.name, value: item.id}})"
                        />
                        
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Líder"
                    label-for="leaders"
                    :class="stateErrorLider && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="leader"
                        :options="contextoList.leaders.map((item) => {return {label: item.name, value: item.id}})"
                        />
                        
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Operadores"
                    label-for="operators"
                    :class="stateErrorOperador && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="operators"
                        :options="contextoList.operators.map((item) => {return {label: item.name, value: item.id}})"
                        multiple
                      />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group
                    label="Família"
                    label-for="familia"
                    :class="stateErrorFamilia && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="familia"
                        :options="contextoList.families.map((item) => {return {label: item, value: item}})"
                        multiple
                      />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group
                    label="Modelo"
                    label-for="modelo"
                    :class="stateErrorModelo && 'invalid'"
                    invalid-feedback="Campo obrigatório"
                    class="item-form"
                    >
                      <v-select
                        placeholder="Selecione"
                        v-model="modelo"
                        :options="contextoList.models.map((item) => {return {label: item, value: item}})"
                        multiple
                      />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                    <b-form-group>
                        <b-button v-if="!sendingForm"
                        variant="primary"
                        class="form-control"
                        @click="createWorkcenter()"
                        >
                        Salvar
                        </b-button>

                    <b-button v-if="sendingForm"
                        variant="primary"
                        disabled
                        class="form-control"
                    >
                        <b-spinner small />
                        Loading ...
                    </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'

import {
  BAvatar, BListGroup, BListGroupItem, BCardText, BForm, BFormGroup, BFormInput, BFormSelect, BButton, BSpinner, BRow, BCol, BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    BListGroup,
    BListGroupItem,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BSpinner,
    BRow,
    BCol,
    BFormTextarea,
    vSelect,
    flatPickr,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    contextoList: {
      default: [],
      type: Array,
    },
  },
  data() {
    return {
      name: '',
      leader: null,
      operators: null,
      costCenter: null,
      familia:null,
      sendingForm: false,
      nomeState:null,
      stateErrorOperador:false,
      stateErrorLider:false,
      stateErrorCentroCusto:false,
      stateErrorFamilia:false,
      modelo:null,
      stateErrorModelo:false
    }
  },
  methods: {
    validaCampos(){
      this.nomeState = this.name ? null : false 
      this.stateErrorLider = this.leader ? false : true
      this.stateErrorOperador = this.operators ? false : true
      this.stateErrorCentroCusto = this.costCenter ? false : true
      this.stateErrorModelo = this.modelo && this.modelo.length > 0 ? false : true
      this.stateErrorFamilia = this.familia && this.familia.length > 0? false : true
    },
    createWorkcenter(){
        this.validaCampos();
        if(this.nomeState != false && !this.stateErrorOperador && !this.stateErrorLider && !this.stateErrorCentroCusto && !this.stateErrorFamilia && !this.stateErrorModelo){
          let operatorsIds = []
          this.operators.forEach(el => operatorsIds.push(el.value))
          let familiaIds = []
          this.familia.forEach(el => familiaIds.push(el.value))
          let modelsIds = []
          this.modelo.forEach(el => modelsIds.push(el.value))

          this.sendingForm = true
          this.$http.post(`/api/workcenters`, 
            {name: this.name,
            leader_id: this.leader.value, 
            operators_id: operatorsIds,
            cost_center_id: this.costCenter.value,
            family: familiaIds,
            model:modelsIds
            }).then(res => { 
                  this.sendingForm = false
                  this.$emit('refetch-data')
                  this.$emit('show-message')
                  this.showToast('Sucesso', 'SmileIcon', 'Centro de trabalho criado com sucesso', 'success')
              })
              .catch((error) => {
                  this.sendingForm = false
                  this.showToast('Error!', 'FrownIcon', error.response.data.message, 'danger')
              })
            
            this.name = ''
            this.leader =  null
            this.operators = null
            this.costCenter =null
            this.familia = null
        }
    },
    showToast(title, icon, text, variant) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          text: text,
          variant,
        },
      })
    },
  }
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}

.form-control.is-invalid{
  background-image: none !important;
}

.form-group{
  &.item-form{
    margin-bottom: 0;
  }
  &.invalid{
    .vs__dropdown-toggle{
      border-color: red !important;
    }
    .invalid-feedback{
      display: block;
    }
  }
}

</style>